import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const formatDateTime = (dateTime: Date | string | undefined): string => {
  if (!dateTime) return ''
  return dayjs.utc(dateTime).local().format('DD-MM-YYYY [at] HH:mm')
}
